export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6301.1e118925.jpg";